<template>
  <div class="main-content">
    <template>
      <div class="page-content">
        <div class="container">
          <section>
            <div class="page-title">
              <h2>Aircraft</h2>
            </div>
            <div class="aircrafts" v-if="isLoad">
              <div v-for="(item, index) in aircrafts" class="aircrafts__item">
                <div class="aircrafts__inputs-row">
                  <div class="aircrafts__input-group">
                    <div class="aircrafts__input-label">Name</div>
                    <div class="aircrafts__input">
                      <BasicInput type="text" v-model="item.name"/>
                    </div>
                    <div class="aircrafts__error-text" v-if="isError && !item.name">
                      Field should not be empty.
                    </div>
                  </div>
                  <div class="aircrafts__input-group">
                    <div class="aircrafts__input-label">Capacity</div>
                    <div class="aircrafts__input">
                      <BasicInput type="number" v-model="item.capacity"/>
                    </div>
                    <div class="aircrafts__error-text" v-if="isError && !item.capacity">
                      Field should not be empty.
                    </div>
                  </div>
                  <div class="aircrafts__input-group" style="display:flex; flex-direction: column; min-width: 200px">
                    <div class="aircrafts__input-label">Air Companies</div>
                    <div class="aircrafts__input" style="display: flex; flex: 1;">
                      <v-select
                          v-model="item.companyIds"
                          :options="companies"
                          :reduce="(i) => i.id"
                          :filterable="false"
                          :clearable="false"
                          :searchable="false"
                          label="name"
                          class="aircrafts__multiselect"
                          placeholder="Select company"
                          multiple
                      >
                        <template #open-indicator>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="5"
                              viewBox="0 0 8 5"
                              fill="none">
                            <path
                                d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                fill="#606060" />
                          </svg>
                        </template>
                        <template #option="option">
                          <div class="aircrafts__fake-checkbox">
                            <Checkbox label="" :value="item.companyIds.includes(option.id)" />
                            {{ option.name }}
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div>
                            {{ option.name }}
                          </div>
                        </template>
                        <template
                            #selected-option-container="{ option, deselect, multiple, disabled }"
                        >
                          <div class="vs__selected">
                            {{ option.name }}
                            <div class="vs__deselect" @click="() => deselect(option.id)">
                              <svg data-v-536778c1="" width="1em" height="1em" class="icon icon-close"><use data-v-536778c1="" xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use></svg>
                            </div>
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <button
                      type="button"
                      class="btn btn--remove aircrafts__delete-button"
                      @click="deleteAircraft(item.id)"
                  >
                    <svg width="1em" height="1em" class="icon icon-close">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                    </svg>
                  </button>
                </div>
                <div class="aircrafts__toilet-checkbox">
                  <Checkbox label="Toilet available" v-model="item.isToiletAvailable"/>
                </div>
                <div class="form-control-photo-group form-control-photo-group--squared">
                  <input type="file" :id="'photo_load1' + index" class="input-hidden"/>
                  <label  class="form-control-photo" v-if="!item.photo" @click="idPhoto = index; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
                  <div class="form-control-photo" v-if="item.photo"><span class="form-control-photo__box h-object-fit"><img
                      :src="`${API}/documents/share/images/${item.photo}?size=MEDIUM`" alt="photo"></span>
                    <button type="button" class="btn btn--remove" @click="item.photo = null">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="form-control-photo-content">
                    <div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
                    <div class="aircrafts__error-text" v-if="isError && !item.photo">
                      Field should not be empty.
                    </div>
                    <div class="form-control-photo-content__line">
                      <label  class="btn btn--rounded btn-photo-load" @click="idPhoto = index; $emit('changeImage', 'itinerary')">{{item.photo ? 'Change photo' : 'Add Photo'}}</label>
                    </div>
                    <div class="form-control-photo-content__line" v-if="!item.photo"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
                  </div>
                </div>
              </div>
              <div class="aircrafts__buttons">
                <button
                    @click="addAircraft()"
                    class="btn btn--green edit-popup__submit make-story__collapse__inner__line-btn">
                  <span>Add Aircraft</span>
                </button>
                <button
                    @click="updateAircrafts()"
                    class="btn btn--green edit-popup__submit make-story__collapse__inner__line-btn">
                  <span>Save Changes</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {API, getAirlinesAll, getPlanes, updatePlanes} from "@/utilites/api";
import BasicInput from "@/components/UI/Inputs/BasicInput.vue";
import ClassicSelect from "@/components/UI/ClassicSelect/ClassicSelect.vue";
import Checkbox from "@/components/UI/Checkbox/Checkbox.vue";
export default {
  name: 'Aircrafts',
  props: ['uploadedFile'],
  data() {
    return {
      API: API,
      aircrafts: [{id: 1}],
      companies: [],
      isLoad: false,
      isError: false,
    }
  },
  components: {Checkbox, ClassicSelect, BasicInput},
  computed: {
  },
  watch: {
    uploadedFile(){
      if(this.uploadedFile){
        this.aircrafts = this.aircrafts.map((item, index) => {
          if(this.idPhoto === index){
            return {
              ...item,
              ['photo']: this.uploadedFile
            }
          }
          return item
        })
      }
    }
  },
  methods: {
    deleteAircraft(id){
      this.aircrafts = this.aircrafts.filter(aircraft => aircraft.id !== id)
    },
    addAircraft() {
      this.aircrafts = [...this.aircrafts, {capacity: '', companyId: null, isToiletAvailable: false, name: '', photo: ''}]
    },
    updateAircrafts() {
      if (this.isFieldsFilled()) {
        updatePlanes({ planes: this.aircrafts }).then(_ => {
          this.$emit('confirmed')
          this.isError = false;
        })
      } else {
        this.isError = true;
      }
    },
    isFieldsFilled() {
      return this.aircrafts.every(aircraft => {
        return aircraft.name &&
            aircraft.capacity &&
            aircraft.photo
          }
      );
    }
  },
  mounted() {
    Promise.all([getAirlinesAll(), getPlanes()]).then(res => {
      this.isLoad = true;
      this.companies = res[0] || [];
      this.aircrafts = res[1].data.planes || [];
    });
  },
}
</script>
<style lang="scss" scoped>
.aircrafts {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #E1E1E1;

  &__item {
    border-bottom: 1px solid #E1E1E1;
    padding: 25px 0;
  }

  &__input-group {}
  &__input-label {
    margin-bottom: 3px;
    font-weight: 500;
    font-size: 12px;
  }
  &__inputs-row {
    display: flex;
    flex: 1;
    gap: 12px;
  }
  &__delete-button {
    align-self: center;
    margin-top: 15px;
    margin-left: 30px;
  }
  &__toilet-checkbox {
    margin: 15px 0;
  }
  &__buttons {
    margin-top: 20px;
    display: flex;
    gap: 15px;
    button {
      margin: 0;
    }
  }
  &__error-text {
    color: red;
    margin-top: 3px;
    font-weight: 600;
  }

  &__fake-checkbox {
    display: flex; align-items: center;
  }
}
</style>

<style lang="scss">
.aircrafts__multiselect {
  display: flex;
  height: 100%;
  flex: 1;

  & .vs__dropdown-toggle {
    min-width: 200px;
    width: auto;
  }

  & .vs__selected {
    font-size: 12px;
    background: transparent;
    padding: 0 8px;
  }

  & .vs__dropdown-option {
    color: #444444;
    font-size: 12px;
    padding: 3px 10px;
  }
  & .vs__deselect {
    font-size: 8px;
    color: red;
  }
  & .vs__dropdown-option--selected {
    font-weight: 700;
    color: #000000;

    .checkbox {
      display: flex;
    }
  }

  & .vs--unsearchable .vs__search {
    font-size: 12px;
  }

  &.vs--open .vs__actions svg {
    transform: rotate(180deg);
  }
}
</style>